import type { NskResponse } from "~/models/Api";
import type { DealConstructionScheduleEdit } from "~/models/DealConstructionSchedule";
import { putRequest } from "../api_handler";

const paths = {
	update: "/deals/:deal_id/deal_construction_schedules"
};

export const update = async (
	dealId: number,
	schedules: DealConstructionScheduleEdit[]
): Promise<NskResponse> =>
	putRequest(paths.update.replace(":deal_id", String(dealId)), {
		dealConstructionSchedules: schedules
	});
